import React from 'react'

import routes from 'src/lib/rails-routes/rails-routes'
import { t } from 'src/lib/i18n-react'
import { usePageParams } from 'src/utils/params'
import { Box } from '@chatterbug/aaron'

import AchievementWidgetHeader from './subcomponents/AchievementWidgetHeader/AchievementWidgetHeader'
import AchievementWidgetSkeleton from './AchievementWidgetSkeleton'
import AchievementWidgetFooter from './subcomponents/AchievementWidgetFooter/AchievementWidgetFooter'
import AchievementWidgetBody from './subcomponents/AchievementWidgetBody/AchievementWidgetBody'

const TYPES = {
  LIVE_LESSON: 'liveLesson',
  CONCEPT: 'concept',
  FLASHCARDS: 'flashcards',
  MEDIA: 'media',
  WRITING: 'writing',
}

const getTitleText = (type) => {
  return (
    {
      liveLesson: t('Live Lessons'),
      concept: t('Concepts'),
      flashcards: t('Flashcards'),
      writing: t('Writing Practice'),
      flashCards: t('Flashcards'),
      media: t('Media'),
    }[type] || t('Media')
  )
}

const AchievementWidget = ({
  activityInfo,
  liveLessonInfo,
  showPlaceholder,
  correctionCount,
  widgetType,
  footerStats,
  linkHash,
  ...rest
}) => {
  const { l2Code } = usePageParams()
  const getLink = () => {
    if (!linkHash) {
      return linkHash
    }
    if (widgetType === TYPES.LIVE_LESSON) {
      return routes.chat_show(l2Code, linkHash)
    }
    return routes.language_study({
      code: l2Code,
      activity: linkHash,
      resume: false,
    })
  }
  const link = getLink()
  return (
    <Box
      as="a"
      href={link ? link : undefined}
      pointer={link ? 'cursor' : null}
      style={{
        textDecoration: 'none',
        color: 'black',
      }}
    >
      <AchievementWidgetSkeleton
        headerSection={
          widgetType === 'flashcards' ? null : (
            <AchievementWidgetHeader
              widgetType={widgetType}
              correctionCount={correctionCount}
              showPlaceholder={showPlaceholder}
            />
          )
        }
        bodySection={
          <AchievementWidgetBody
            linkHash={linkHash}
            activityInfo={activityInfo}
            widgetType={widgetType}
            liveLessonInfo={liveLessonInfo}
            showPlaceholder={showPlaceholder}
          />
        }
        footerSection={
          <AchievementWidgetFooter
            showPlaceholder={showPlaceholder}
            widgetType={widgetType}
            statItems={footerStats}
          />
        }
        {...rest}
      />
    </Box>
  )
}

export default AchievementWidget
export { TYPES, getTitleText }
